import { apiClient, handleResp } from './utils';

export default {
  getStoryVideos(slug) {
    return handleResp(apiClient().get('/intro_videos/primary_story_videos?slug=' + slug));
  },
  create(payload) {
    return handleResp(apiClient().post('/intro_videos', payload));
  },
  delete(payload) {
    return handleResp(apiClient().delete('/intro_videos/' + payload.id));
  },
  fetch(type, language) {
    const langQuery = language ? `&language=${encodeURIComponent(language)}` : '';
    return handleResp(apiClient().get('/intro_videos/fetch?type=' + type + langQuery));
  },
  getSlug(type) {
    return handleResp(apiClient().get('/intro_videos/get_slug?type=' + type));
  },
  checkSlug(type, slug, lang = 'en') {
    return handleResp(apiClient().get(`/intro_videos/check_slug_validity?type=${type}&slug=${slug}&lang=${lang}`));
  },
  saveSlug(type, slug) {
    return handleResp(apiClient().post('/intro_videos/save_slug', { type, slug }));
  },
};
